/* Connect the legacy product gallery when the Slick runtime is absent. */
(() => {
  if (window.rhLegacyProductGalleryLoaded) return;
  window.rhLegacyProductGalleryLoaded = true;

  const init = (gallery) => {
    const main = gallery.querySelector('[data-image-gallery-main]');
    const strip = gallery.querySelector('.productView-for');
    if (!main || !strip || main.dataset.rhGalleryReady || main.classList.contains('slick-initialized')) return;

    const slides = Array.from(main.children).filter((slide) => slide.matches('.productView-image'));
    const items = Array.from(strip.children).map((thumbnail) => {
      const mediaId = (thumbnail.dataset.mediaId || '').split('-').pop();
      const slide = slides.find((item) => item.querySelector('[data-media-id]')?.dataset.mediaId === mediaId);
      const control = thumbnail.querySelector('.productView-thumbnail-link');
      return { mediaId, slide, control };
    }).filter((item) => item.slide && item.control);
    if (items.length < 2) return;
    main.dataset.rhGalleryReady = 'true';
    let active = items[0];

    const align = () => {
      if (main.classList.contains('slick-initialized')) return;
      // Scroll this viewport only, keeping full-resolution media and page position.
      const delta = active.slide.getBoundingClientRect().left - main.getBoundingClientRect().left - main.clientLeft;
      if (Math.abs(delta) > 1) main.scrollBy({ left: delta, behavior: 'instant' });
    };
    const select = (item) => {
      if (main.classList.contains('slick-initialized')) return;
      active = item;
      align();
      slides.forEach((slide) => {
        const selected = slide === item.slide;
        slide.setAttribute('aria-hidden', String(!selected));
        if (!selected) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      items.forEach((entry) => entry.control.setAttribute('aria-pressed', String(entry === item)));
    };

    items.forEach((item) => {
      const control = item.control;
      control.setAttribute('role', 'button');
      control.tabIndex = 0;
      control.setAttribute('aria-label', control.querySelector('img')?.alt || item.slide.querySelector('img')?.alt || item.mediaId);
      control.addEventListener('click', (event) => {
        if (main.classList.contains('slick-initialized')) return;
        event.preventDefault();
        select(item);
      });
      control.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select(item);
        }
      });
    });

    gallery.closest('.productView')?.addEventListener('rh:variant-change', (event) => {
      const mediaId = String(event.detail?.variant?.featured_media?.id || '');
      const item = items.find((entry) => entry.mediaId === mediaId);
      if (item) select(item);
    });
    select(active);
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(align);
      observer.observe(main);
      const section = gallery.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
  };

  const boot = () => document.querySelectorAll('.product-step-by-step [data-image-gallery]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
